import { render, staticRenderFns } from "./SearchApp.vue?vue&type=template&id=151a71bf&scoped=true&"
import script from "./SearchApp.vue?vue&type=script&lang=js&"
export * from "./SearchApp.vue?vue&type=script&lang=js&"
import style0 from "./SearchApp.vue?vue&type=style&index=0&id=151a71bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151a71bf",
  null
  
)

export default component.exports